export default __webpack_public_path__ + "static/media/Hephestus-light.1bb5439f.gif";